import Content from "../components/content/content";
import Hero from "../components/hero/hero";

function Home() {
  return (
    <>
      <Hero />
      <Content />
    </>
  );
}

export default Home;
